import APIService from 'services/APIService'

const api = APIService()

export const getWiki = ({ bpId }) =>
  api.get(`/building-passport/${bpId}/wiki`)

export const refreshWiki = ({ bpId }) =>
  api.post(`/building-passport/${bpId}/wiki/refresh`)

export const exportWikiPdf = ({ bpId }) =>
  api.get(`/building-passport/${bpId}/wiki/export/pdf`, { responseType: 'blob' })
